import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const ChecklistNote: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_29793)'>
        <path
          d='M20.0704 19.3525V21.5181C20.0704 22.3346 19.4086 22.9966 18.592 22.9966H5.47851C4.66198 22.9966 4 22.3346 4 21.5181V3.66198C4 2.84544 4.66198 2.18359 5.47851 2.18359H7.41114'
          stroke='url(#paint0_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.0675 19.998L20.0674 3.66198C20.0674 2.84544 19.4055 2.18359 18.589 2.18359H16.6562'
          stroke='url(#paint1_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.9297 7.19141H17.0777'
          stroke='url(#paint2_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.99609 7.02933L7.69975 7.73298L9.56945 5.86328'
          stroke='url(#paint3_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.9297 10.3711H17.0777'
          stroke='url(#paint4_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.99609 10.209L7.69975 10.9127L9.56945 9.04297'
          stroke='url(#paint5_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.9297 13.543H17.0777'
          stroke='url(#paint6_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.99609 13.3848L7.69975 14.0885L9.56945 12.2188'
          stroke='url(#paint7_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.9297 16.7227H15.2958'
          stroke='url(#paint8_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.99609 16.5606L7.69975 17.2642L9.56945 15.3945'
          stroke='url(#paint9_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.9297 19.9023H17.0777'
          stroke='url(#paint10_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.99609 19.7403L7.69975 20.4439L9.56945 18.5742'
          stroke='url(#paint11_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.6582 1H7.41016V3.37231H16.6582V1Z'
          stroke='url(#paint12_linear_12280_29793)'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_29793'
          x1='7.32781'
          y1='3.60281'
          x2='18.1505'
          y2='20.3516'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_29793'
          x1='17.3626'
          y1='3.39834'
          x2='24.1606'
          y2='6.00739'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_29793'
          x1='12.2028'
          y1='7.2596'
          x2='12.2948'
          y2='8.39286'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_29793'
          x1='7.52898'
          y1='5.99077'
          x2='8.21234'
          y2='7.87588'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_29793'
          x1='12.2028'
          y1='10.4393'
          x2='12.2948'
          y2='11.5726'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_29793'
          x1='7.52898'
          y1='9.17046'
          x2='8.21234'
          y2='11.0556'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_29793'
          x1='12.2028'
          y1='13.6112'
          x2='12.2948'
          y2='14.7444'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_29793'
          x1='7.52898'
          y1='12.3462'
          x2='8.21234'
          y2='14.2314'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_29793'
          x1='11.8338'
          y1='16.7908'
          x2='11.9625'
          y2='17.9169'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_29793'
          x1='7.52898'
          y1='15.522'
          x2='8.21234'
          y2='17.4071'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_29793'
          x1='12.2028'
          y1='19.9705'
          x2='12.2948'
          y2='21.1038'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_29793'
          x1='7.52898'
          y1='18.7017'
          x2='8.21234'
          y2='20.5868'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_29793'
          x1='9.3252'
          y1='1.16177'
          x2='9.66598'
          y2='3.82432'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_29793'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChecklistNote;
